let loadingPromise: Promise<void> | null = null;

export const loadScriptAsync = (src: string) => {
  if (typeof window === 'undefined') return Promise.resolve();

  // If Maps is already available, don't load again.
  if ((window as any).google?.maps?.places) return Promise.resolve();

  // Reuse the in-flight promise so we never insert multiple scripts.
  if (loadingPromise) return loadingPromise;

  loadingPromise = new Promise<void>((resolve, reject) => {
    const existing = window.document.querySelector<HTMLScriptElement>('script[data-google-maps="true"]');
    if (existing) {
      // If someone already inserted it, wait until places is available
      waitForPlaces(resolve, reject);
      return;
    }

    const script = window.document.createElement('script');
    script.src = src;
    script.async = true;
    script.defer = true;
    script.setAttribute('data-google-maps', 'true');

    script.addEventListener('load', () => {
      waitForPlaces(resolve, reject);
    });
    script.addEventListener('error', (err) => reject(err));

    window.document.body.appendChild(script);
  });

  return loadingPromise;
};

const waitForPlaces = (resolve: () => void, reject: (e: any) => void) => {
  const start = Date.now();
  const timeoutMs = 10000;

  const tick = () => {
    if ((window as any).google?.maps?.places) {
      resolve();
      return;
    }
    if (Date.now() - start > timeoutMs) {
      reject(new Error('Google Maps loaded, but google.maps.places is not available (missing libraries=places?)'));
      return;
    }
    setTimeout(tick, 50);
  };

  tick();
};
